(function () {
  if (!window.theme || !theme.storefrontApi || !theme.storefrontApi.accessToken) return;

  var STOREFRONT_ENDPOINT = 'https://' + theme.storefrontApi.domain + '/api/' + theme.storefrontApi.apiVersion + '/graphql.json';
  var KLAVIYO_EVENT_NAME = 'Cart Checkout Link';
  var KLAVIYO_COMPANY_ID = 'U9ew6u';
  var KLAVIYO_EVENTS_ENDPOINT = 'https://a.klaviyo.com/client/events/?company_id=' + KLAVIYO_COMPANY_ID;
  var KLAVIYO_REVISION = '2025-07-15';
  var ANONYMOUS_ID_STORAGE_KEY = 'klaviyo_checkout_bridge_anonymous_id';

  var CART_CREATE_MUTATION =
    'mutation CartCreate($lines: [CartLineInput!]!) {' +
    '  cartCreate(input: { lines: $lines }) {' +
    '    cart { checkoutUrl }' +
    '    userErrors { field message }' +
    '  }' +
    '}';

  function storefrontRequest(query, variables) {
    return fetch(STOREFRONT_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': theme.storefrontApi.accessToken,
      },
      body: JSON.stringify({ query: query, variables: variables }),
    }).then(function (response) {
      return response.json();
    });
  }

  function toVariantGid(variantId) {
    return 'gid://shopify/ProductVariant/' + variantId;
  }

  function getCheckoutUrl() {
    return fetch(theme.routes.cart_url + '.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        if (!cart.items.length) return null;

        var lines = cart.items.map(function (item) {
          return { merchandiseId: toVariantGid(item.variant_id), quantity: item.quantity };
        });

        return storefrontRequest(CART_CREATE_MUTATION, { lines: lines }).then(function (result) {
          var errors = result.data && result.data.cartCreate && result.data.cartCreate.userErrors;
          if (errors && errors.length) {
            throw new Error(errors.map(function (e) { return e.message; }).join(', '));
          }
          return { checkoutUrl: result.data.cartCreate.cart.checkoutUrl, cart: cart };
        });
      });
  }

  function readCookie(name) {
    var match = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
    return match ? decodeURIComponent(match[1]) : null;
  }

  function getKlaviyoAnonymousId() {
    var klaId = readCookie('__kla_id');
    if (klaId) {
      try {
        var cid = JSON.parse(atob(klaId)).cid;
        if (cid) return atob(cid);
      } catch (e) {
        // fall through to local fallback id
      }
    }

    var storedId = localStorage.getItem(ANONYMOUS_ID_STORAGE_KEY);
    if (storedId) return storedId;

    var newId = (crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(16).slice(2));
    localStorage.setItem(ANONYMOUS_ID_STORAGE_KEY, newId);
    return newId;
  }

  function trackKlaviyoEvent(checkoutUrl, cart) {
    var properties = {
      CheckoutURL: checkoutUrl,
      $value: cart.total_price / 100,
      ItemNames: cart.items.map(function (item) { return item.product_title; }),
    };

    // Prefer the official onsite SDK: it already knows this browser's real
    // Klaviyo identity, so the event lands on the same profile as every
    // other onsite-tracked interaction instead of a disconnected anonymous one.
    if (window.klaviyo && typeof klaviyo.track === 'function') {
      if (theme.customerEmail && typeof klaviyo.identify === 'function') {
        try { klaviyo.identify({ email: theme.customerEmail }); } catch (e) {}
      }
      return klaviyo.track(KLAVIYO_EVENT_NAME, properties);
    }

    // Fallback for the rare case the onsite SDK hasn't loaded.
    var profileAttributes = { anonymous_id: getKlaviyoAnonymousId() };
    if (theme.customerEmail) {
      profileAttributes.email = theme.customerEmail;
    }

    var payload = {
      data: {
        type: 'event',
        attributes: {
          properties: properties,
          metric: { data: { type: 'metric', attributes: { name: KLAVIYO_EVENT_NAME } } },
          profile: { data: { type: 'profile', attributes: profileAttributes } },
        },
      },
    };

    return fetch(KLAVIYO_EVENTS_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: KLAVIYO_REVISION },
      body: JSON.stringify(payload),
    });
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
    getCheckoutUrl()
      .then(function (result) {
        if (result) trackKlaviyoEvent(result.checkoutUrl, result.cart);
      })
      .catch(function (error) {
        console.error('[klaviyo-checkout-bridge]', error);
        try {
          if (window.posthog && typeof posthog.captureException === 'function') {
            posthog.captureException(error, { source: 'klaviyo-checkout-bridge' });
          }
        } catch (e) {}
      });
  });
})();
